import axios from 'axios';
import { decryptData } from '../util/cryptoUtil.js';
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 10000,
});

axiosInstance.interceptors.response.use((response) => {
  const encrypted = response.data?.payload || response.data;
  try {
    const decrypted = JSON.parse(decryptData(encrypted));
    return { data: decrypted };
  } catch (e) {
    return Promise.reject(new Error('Decryption failed'));
  }
},

async (error) => {
    const encryptedError = error?.response?.data?.payload;
    let decryptedErrorData = null;
    if (encryptedError) {
      try {
        decryptedErrorData = JSON.parse(decryptData(encryptedError));
      } catch (e) {
        console.error('Failed to decrypt error payload:', e);
      }
    }
    if (decryptedErrorData) {
      return Promise.reject({ response : {data: decryptedErrorData} });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
